import { createSlice } from "@reduxjs/toolkit";
import { fetchMapSchoolsStatsData } from "../thunks/dashboardThunk"; 

const dashboarStudentsMapStateInt = createSlice({
  name: "MapStudentsStatsInt",
  initialState: {
    data: {
      data:[],
      statusCode:0,
      message:"",
      success:false
    },
    
    isLoading:false,
    isError:false
  },

 
  reducers: {},
  extraReducers: (builder) => {
    
    builder
      .addCase(fetchMapSchoolsStatsData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchMapSchoolsStatsData.fulfilled, (state, action) => {
        state.data = action.payload.data===""?[]:action.payload;
        state.isLoading = false;
      })
      .addCase(fetchMapSchoolsStatsData.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
      })
      
  },
});

export default dashboarStudentsMapStateInt.reducer;